// extracted by mini-css-extract-plugin
module.exports = {"gas":"Tx_gas__2j3tc","select":"Tx_select__2iPfc","icon":"Tx_icon__STRWb","hidden":"Tx_hidden__3uUrW"};